import React, { useMemo, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const FilterSelect = ({ testId, value, onChange, allLabel, options }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-56" data-testid={testId}><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{allLabel}</SelectItem>
      {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
    </SelectContent>
  </Select>
);

const uniq = (arr) => [...new Set(arr.filter(Boolean))].sort();

// Historique complet des notes (élève / parent) avec filtres
export const GradeHistoryTable = ({ grades, showStudent }) => {
  const [child, setChild] = useState('all');
  const [subject, setSubject] = useState('all');
  const [period, setPeriod] = useState('all');
  const rows = useMemo(() => grades.filter((g) =>
    (child === 'all' || g.student_name === child) && (subject === 'all' || g.subject_name === subject) && (period === 'all' || g.period === period)
  ), [grades, child, subject, period]);

  return (
    <Card className="card" data-testid="grade-history">
      <CardContent className="pt-6 space-y-4">
        <div className="flex flex-wrap gap-3">
          {showStudent && <FilterSelect testId="grade-filter-child" value={child} onChange={setChild} allLabel="Tous les enfants" options={uniq(grades.map((g) => g.student_name))} />}
          <FilterSelect testId="grade-filter-subject" value={subject} onChange={setSubject} allLabel="Toutes les matières" options={uniq(grades.map((g) => g.subject_name))} />
          <FilterSelect testId="grade-filter-period" value={period} onChange={setPeriod} allLabel="Toutes les périodes" options={uniq(grades.map((g) => g.period))} />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500 border-b">
                {showStudent && <th className="py-2 pr-3">Enfant</th>}
                <th className="py-2 pr-3">Matière</th><th className="py-2 pr-3">Évaluation</th><th className="py-2 pr-3">Date</th>
                <th className="py-2 pr-3">Période</th><th className="py-2 pr-3 text-right">Note</th><th className="py-2 text-right">Coef.</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((g) => (
                <tr key={g.id} className="border-b last:border-0" data-testid={`grade-row-${g.id}`}>
                  {showStudent && <td className="py-2 pr-3">{g.student_name}</td>}
                  <td className="py-2 pr-3 font-medium">{g.subject_name || '—'}</td>
                  <td className="py-2 pr-3">{g.assessment_title}{g.comments && <div className="text-xs text-gray-500 italic">{g.comments}</div>}</td>
                  <td className="py-2 pr-3">{new Date(g.assessment_date || g.created_at).toLocaleDateString('fr-FR')}</td>
                  <td className="py-2 pr-3">{g.period || '—'}</td>
                  <td className={`py-2 pr-3 text-right font-semibold ${g.grade === null ? 'text-gray-500' : g.grade / (g.max_grade || 20) >= 0.5 ? 'text-green-600' : 'text-red-600'}`}>
                    {g.grade !== null ? `${g.grade}/${g.max_grade || 20}` : 'ABS'}
                  </td>
                  <td className="py-2 text-right">{g.coefficient}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <p className="text-center text-gray-500 py-6">Aucune note pour ces filtres.</p>}
        </div>
      </CardContent>
    </Card>
  );
};
